import React, { useContext, useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import ModNomina from './ModNomina';
import { AddEmploye } from './AddEmploye';
import { AuthContext } from '../../auth/AuthContext';
import { checkAccess } from '../../helpers/details';

const ProfileCom = ({ data, callBk }) => {
    const [show, setShow] = useState(false);
    const [showu, setShowu] = useState(false);
    const { auth } = useContext(AuthContext);

    const permisos = checkAccess('Empleados', auth.accesos);

    const { emp_edit, nom_add } = permisos.functions;

    return (
        <Card style={{ background: '#0A6681' }}>
            <Card.Body className="profile-user-box">
                <Row>
                    <Col sm={8}>
                        <Row className="align-items-center">
                            <Col className="col-auto">
                                <div className="avatar-lg">
                                    <span className="avatar-title bg-info rounded-circle">
                                        <h3>{data.nombre.substring(0, 2)}</h3>
                                    </span>
                                </div>
                            </Col>
                            <Col>
                                <div>
                                    <h4 className="mt-1 mb-1 text-white">{data.nombre}</h4>
                                    <p className="font-13 text-white-50">{data.direccion}</p>

                                    <ul className="mb-0 list-inline text-light">
                                        <li className="list-inline-item me-3 d-flex">
                                            <i className="mdi mdi-phone me-1 mt-1"></i>
                                            <h5 className="mb-1 text-white">{data.telefono}</h5>
                                        </li>
                                        <li className="list-inline-item">
                                            <h5 className="mb-1 text-white">${Math.round(data.sueldo * 30)}</h5>
                                            <p className="mb-0 font-13 text-white-50">Sueldo Mensual</p>
                                        </li>
                                    </ul>
                                </div>
                            </Col>
                        </Row>
                    </Col>

                    <Col sm={4} className="d-flex">
                        {nom_add && (
                            <div className="text-center mt-sm-0 mt-3 mx-2 text-sm-end">
                                <button type="button" className="btn btn-light" onClick={() => setShow(true)}>
                                    <i className="mdi mdi-badge-account-outline"></i> Generar nomina
                                </button>
                            </div>
                        )}
                        {emp_edit && (
                            <div className="text-center mt-sm-0 mt-3 text-sm-end">
                                <button type="button" className="btn btn-light" onClick={() => setShowu(true)}>
                                    <i className="mdi mdi-account-edit me-1"></i> Editar perfil
                                </button>
                            </div>
                        )}
                    </Col>
                </Row>
            </Card.Body>
            <ModNomina show={show} onClose={() => setShow(false)} dia={data.sueldo} user={data} />
            <AddEmploye show={showu} callBk={callBk} onClose={() => setShowu(false)} item={data} />
        </Card>
    );
};

export default ProfileCom;
